import React, {Component} from "react";

import {EditorState, convertToRaw, ContentState} from 'draft-js';
import {Editor} from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import {Add, Delete} from "../../api/Menu";
import {CreateOrUpdate, Get as GetPost} from "../../api/Post";
import {inject} from "mobx-react";
import AddFile from "../AddFile";
import { translate } from "../../dictionaries";

@inject(stores => ({
        AuthorizationStore: stores.rootStore.Authorization,
    })
)

class EditablePost extends React.Component {
    constructor(props) {
        super(props);

        let editable = null;

        this.state = {
            editorState: EditorState.createEmpty(),
            editable: editable,
            loading: true
        };

        this.config = {
            fontFamily: {
                options: ["Calibri"]
            },
            link: {
                defaultTargetOption: "_blank"
            }
        };
    }

    componentDidMount() {
        this.setEditable(this.props.menu);
    }


    setEditable = (menu) => {
        menu.forEach(async (item) => {
            if (item.isEdit === true) {
                const resp = await GetPost(item.id, this.props.AuthorizationStore.token, true);

                let editorStateRU = null;
                let editorStateEN = null;
                let editorStateZH = null;

                if (resp.status === 200) {
                    const data = await resp.json();

                    const contentBlockRU = htmlToDraft(data.htmlRussian);
                    editorStateRU = ContentState.createFromBlockArray(contentBlockRU.contentBlocks);
                    const contentBlockZH = htmlToDraft(data.htmlChina);
                    editorStateZH = ContentState.createFromBlockArray(contentBlockZH.contentBlocks);
                    const contentBlockEN = htmlToDraft(data.htmlEnglish);
                    editorStateEN = ContentState.createFromBlockArray(contentBlockEN.contentBlocks);
                }

                this.setState({
                    editable: item,
                    loading: false,
                    editorStateRU: !!editorStateRU ? EditorState.createWithContent(editorStateRU) : EditorState.createEmpty(),
                    editorStateZH: !!editorStateZH ? EditorState.createWithContent(editorStateZH) : EditorState.createEmpty(),
                    editorStateEN: !!editorStateEN ? EditorState.createWithContent(editorStateEN) : EditorState.createEmpty()
                })
            }

            this.setEditable(item.items);
        });
    };

    onChangeRoot = (e) => {
        const editable = this.state.editable;

        editable.isRoot = e.currentTarget.checked;

        this.setState({
            editable: editable
        })
    };

    onChangeColor = (e) => {
        const editable = this.state.editable;

        editable.color = e.currentTarget.value;

        this.setState({
            editable: editable
        })
    };

    onChangeName = (e) => {
        const editable = this.state.editable;

        editable.russianName = e.currentTarget.value;

        this.setState({
            editable: editable
        })
    };
    onChangeNameEnglish = (e) => {
        const editable = this.state.editable;

        editable.englishName = e.currentTarget.value;

        this.setState({
            editable: editable
        })
    };
    onChangeNameChina = (e) => {
        const editable = this.state.editable;

        editable.chinaName = e.currentTarget.value;

        this.setState({
            editable: editable
        })
    };

    post = async () => {
        const model = {
            Id: this.state.editable.id,
            ParentId: this.state.editable.menuId,
            Color: this.state.editable.color,
            IsRoot: this.state.editable.isRoot,
            RussianName: this.state.editable.russianName,
            ChinaName: this.state.editable.chinaName,
            EnglishName: this.state.editable.englishName
        };

        const resp = await Add(model, this.props.AuthorizationStore.token);

        if (resp.status === 200) {
            const data = await resp.json();

            if (resp.status === 200) {
                const model = {
                    MenuId: data.id,
                    HtmlRussian: draftToHtml(convertToRaw(this.state.editorStateRU.getCurrentContent())),
                    HtmlChina: draftToHtml(convertToRaw(this.state.editorStateZH.getCurrentContent())),
                    HtmlEnglish: draftToHtml(convertToRaw(this.state.editorStateEN.getCurrentContent()))
                };


                const resp = await CreateOrUpdate(model, this.props.AuthorizationStore.token);
                if (resp.status === 200) {
                    window.location.reload();
                }
            }
        }
        //  this.props.changeVisible();
    };

    onEditorStateChangeRU = (editorState) => {

        const currentStyles = editorState.getCurrentInlineStyle();

        this.setState({
            editorStateRU: editorState,
        });
    };

    onEditorStateChangeEN = (editorState) => {

        const currentStyles = editorState.getCurrentInlineStyle();

        this.setState({
            editorStateEN: editorState,
        });
    };

    onEditorStateChangeZH = (editorState) => {

        const currentStyles = editorState.getCurrentInlineStyle();

        this.setState({
            editorStateZH: editorState,
        });
    };

    delete = async () => {
        this.setState({
            loading: true
        })

        const resp = await Delete(this.state.editable.id, this.props.AuthorizationStore.token);

        if (resp.status === 200) {
            alert(translate('common.success'));
            window.location.reload();
        } else {
            alert(translate('common.alertError'))
        }

        this.setState({
            loading: false
        })
    };

    handlePastedText = (text, html, editorState, onChange) => {
       
    };

    render() {
        const {editorStateRU, editorStateZH, editorStateEN} = this.state;
        console.log(this.state.editable)
        return (
            <div>
                {
                    !this.state.loading &&
                    <>
                        <p>
                            {translate('common.naming')} на Русском:&nbsp; <input onChange={this.onChangeName} value={this.state.editable.russianName}
                                                   style={{width: 350}}/>
                        </p>
                        <p>
                            {translate('common.naming')} на Китайском:&nbsp; <input onChange={this.onChangeNameChina} value={this.state.editable.chinaName}
                                                   style={{width: 350}}/>
                        </p>
                        <p>
                            {translate('common.naming')} на Английском:&nbsp; <input onChange={this.onChangeNameEnglish} value={this.state.editable.englishName}
                                                   style={{width: 350}}/>
                        </p>
                        <p>
                            {translate('common.corny')}:&nbsp; <input
                            onChange={this.onChangeRoot}
                            checked={this.state.editable.isRoot}
                            className={"checkbox_post"}
                            type={"checkbox"}/>
                        </p>
                        <div>
                            <AddFile/>
                        </div>
                        {
                            !this.state.editable.isRoot &&
                            <div>
                                <span style={{fontWeight: 700}}>Описание на Русском</span>
                                <Editor
                                    toolbar={this.config}
                                    localization={{
                                        locale: 'ru',
                                    }}
                                    editorStyle={{maxHeight: 600, minHeight: 600}}
                                    handlePastedText={this.handlePastedText}
                                    editorState={editorStateRU}
                                    wrapperClassName="editor-wrapper"
                                    editorClassName="editor"
                                    onEditorStateChange={this.onEditorStateChangeRU}
                                />
                                <div style={{marginTop: 12}}/>
                                <span style={{fontWeight: 700}}>Описание на Китайском</span>
                                <Editor
                                    toolbar={this.config}
                                    localization={{
                                        locale: 'zh',
                                    }}
                                    editorStyle={{maxHeight: 600, minHeight: 600}}
                                    handlePastedText={this.handlePastedText}
                                    editorState={editorStateZH}
                                    wrapperClassName="editor-wrapper"
                                    editorClassName="editor"
                                    onEditorStateChange={this.onEditorStateChangeZH}
                                />
                                <div style={{marginTop: 12}}/>
                                <span style={{fontWeight: 700}}>Описание на Английском</span>
                                <Editor
                                    toolbar={this.config}
                                    localization={{
                                        locale: 'en',
                                    }}
                                    editorStyle={{maxHeight: 600, minHeight: 600}}
                                    handlePastedText={this.handlePastedText}
                                    editorState={editorStateEN}
                                    wrapperClassName="editor-wrapper"
                                    editorClassName="editor"
                                    onEditorStateChange={this.onEditorStateChangeEN}
                                />
                            </div>
                        }
                        <p>
                            <button onClick={this.post}>
                                {translate('common.save')}
                            </button>
                        </p>
                        <p>
                            <button onClick={this.props.changeEditable}>
                                {translate('common.cancel')}
                            </button>
                        </p>
                        {
                            !!this.state.editable.id &&
                            <p>
                                <button onClick={this.delete}>
                                    {translate('common.delete')}
                                </button>
                            </p>
                        }
                    </>
                }
            </div>
        )
    }
}

export default EditablePost;